import { useQuery } from '@tanstack/react-query';
import { getCustomerReviews } from 'api/strapi';

const CUSTOMER_REVIEWS_FLAG = 'CUSTOMER_REVIEWS';

const useCustomerReviews = () =>
  useQuery({
    queryKey: [CUSTOMER_REVIEWS_FLAG],
    queryFn: () => getCustomerReviews(),
    gcTime: 1000 * 60 * 60,
    select: res => res.data?.data ?? undefined,
    staleTime: 1000 * 60 * 60,
    retry: 1,
    refetchOnWindowFocus: false
  });

export default useCustomerReviews;
